import { type ThemeTextSizes, ThemeFontWeight } from '@rover/kibble/styles';

import { Props as LinkProps } from '../../core/Link/Link';

export type TextWithSingleInlineLinkProps = Omit<LinkProps, 'children' | 'as'> & {
  /** NOTE: The structure of this goes like "text before <0> link text here </0> text after" */
  paragraphText: string;
  size?: ThemeTextSizes;
  onClick?: () => Promise<void> | void;
  linkFontWeight?: ThemeFontWeight | ThemeFontWeight[];
  asParagraph?: boolean;
};

export const validateParagraphText = (paragraphText: string): void => {
  // Regex here checks to make sure <0> and </0> are being passed in the string and that either text is before or after the link
  const regex = /^(.*?<0>.*?<\/0>.+|.+<0>.*?<\/0>.*)$/;
  if (!regex.test(paragraphText)) {
    throw new Error(
      'Invalid paragraphText structure. It should contain "text before <0> link text here </0> text after", or "text before <0> link text here </0>", or "<0> link text here </0> text after".'
    );
  }
};
